import { DEFAULT_VIEW_ID } from "@components/views/constants";

export const ACTIVE_SERVICES_VIEW_ID = "active-services";
export const MONTH_END_CLOSE_VIEW_ID = "month-end-close";
export const ASSIGNED_TO_ME_WORK_VIEW_ID = "assigned-to-me";
export const UPCOMING_DEADLINES_VIEW_ID = "upcoming-deadlines";
export const NEEDS_ATTENTION_VIEW_ID = "needs-attention";
export const BY_TEAM_MEMBER_VIEW_ID = "by-team-member";
/** Today's "All work" keeps the toolbar's default id, so cached picks of it still match. */
export const ALL_WORK_VIEW_ID = DEFAULT_VIEW_ID;
